import { render } from "./LandingText.vue?vue&type=template&id=211e8ef4"
import script from "./LandingText.vue?vue&type=script&lang=js"
export * from "./LandingText.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__